// eslint-disable-next-line no-unused-vars
import { MKVKRESTPromiseRequest } from '@/utils/utils'

export default {
  state: {
    list: [],
  },
  mutations: {
    SET_INSPECTION_REVIEW_LIST (state, list) {
      state.list = Array.isArray(list) ? list : []
    },
  },
  actions: {
    async fetchInspectionReviewList ({ commit, rootState }) {
      const response = await MKVKRESTPromiseRequest(
        rootState.api.GET_INSPECTION_GL_NOTE_LIST,
        { show_done: true },
      )
      if (response) {
        commit('SET_INSPECTION_REVIEW_LIST', response)
      }
      return response
    },
    async reportGroupLeaderReviewFinished ({ commit, rootState }, inspectionID) {
      return await MKVKRESTPromiseRequest(
        rootState.api.SET_INSPECTION_GL_NOTE_DONE,
        {
          id: inspectionID,
          value: true,
        },
      )
    },
    async revertGroupLeaderReviewFinished ({ commit, rootState }, inspectionID) {
      return await MKVKRESTPromiseRequest(
        rootState.api.SET_INSPECTION_GL_NOTE_DONE,
        {
          id: inspectionID,
          value: false,
        },
      )
    },
  },
  getters: {},
}
